export default {
  breakpoints: {
    small: 400,
    medium: 600,
    large: 1000,
    xlarge: 1200,
    xxlarge: 1600,
  },
  mediaRanges: {
    // Ranges starting form a breakpoint
    'small-up': {min: 'small'},
    'medium-up': {min: 'medium'},
    'large-up': {min: 'large'},
    'xlarge-up': {min: 'xlarge'},
    'xxlarge-up': {min: 'xxlarge'},

    // Ranges between breakpoints
    'small-to-medium': {min: 'small', max: 'medium'},
    'medium-to-large': {min: 'medium', max: 'large'},

    // Ranges up to a breakpoint
    'small-down': {max: 'small'},
    'medium-down': {max: 'medium'},
    'large-down': {max: 'large'},
    'xlarge-down': {max: 'xlarge'},
  }
};



// WEBPACK FOOTER //
// frontend/js/config/index.js